import {Component} from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-noop',
  template: ``
})
export class NoopComponent {
}
